import React, { useEffect, useState }  from 'react';
import PropTypes from "prop-types";
import axios from "axios";
import Swal from 'sweetalert2'
import { useFormik } from 'formik';
import * as yup from 'yup';
import Modal from 'react-bootstrap/Modal';
import MultiSelectDropdown from '../../Common/MultiSelectDropdown'

const validationSchema = yup.object({
    orgs: yup.array().min(1, 'At least one company is required')
});
export const AdminCompetenyClone = ({show, setShow, getList, competencyId, ...rest}) => {
    const handleClose = () => setShow(false);
    const [users, setUsers] = useState([]);
    const [selectedOrgs, setSelectedOrgs] = useState([]);
    const [selectedUsersLoaded, setSelectedUsersLoaded] = useState(false);

    const initialValues = {
        competencyId: competencyId,
        orgs: []
    }

    useEffect(() => {
        getOrgList();
    }, [])

    useEffect(() => {
        setSelectedOrgs([])
        formik.setFieldValue('competencyId', competencyId)
    },[show]);

    useEffect(() => {
        setSelectedUsersLoaded(false);
        console.log("selectedOrgs",selectedOrgs)
        if (selectedOrgs.length > 0) {
            formik.setFieldValue('orgs', selectedOrgs)
            setSelectedUsersLoaded(true);
        }
    }, [selectedOrgs])

    const getOrgList = async() => {
        await axios.get(`/api/teams`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setUsers(result.data.map((data) => {
                    return {id: data.id, name: data.name}
                }))
            }
        })
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
        }
    });

    const handlePopupClose = () => {
        formik.resetForm();
        handleClose()
    }

    const handleSubmit = (values) => {
        console.log(values)
        axios.post(`api/competency/clone`, values).then(res => {
            setShow(false);
            if(res.data.success){
                Swal.fire(res.data.message, '', 'success').then(result => {
                    formik.resetForm();
                    getList();                    
                })                
            } 
            else{
                Swal.fire(res.data.message, '', 'error')
            }
        }).catch((error) => {
            setShow(false);
            // console.log(error.response.data)
            Swal.fire(error.response.data.message, '', 'error')
        });
    }

    return (
        <Modal show={show} onHide={handlePopupClose}>
            <Modal.Header closeButton>
            <Modal.Title>Competency Clone</Modal.Title>
            </Modal.Header>
                <form onSubmit={formik.handleSubmit}>
                    <Modal.Body> 
                        <label className="form-label" htmlFor="basic-icon-default-email">Select Organization</label>
                            {selectedUsersLoaded ?
                                <MultiSelectDropdown
                                    optionsList={users} 
                                    defaultValue={selectedOrgs} 
                                    formik={formik}
                                    orgDropdown={true}
                                />: 
                                <>
                                <MultiSelectDropdown 
                                    optionsList={users} 
                                    // defaultValue={selectedOrgs} 
                                    formik={formik}
                                    orgDropdown={true}
                                />
                                {formik.touched.orgs && formik.errors.orgs && (
                                    <div className="text-danger">{formik.errors.orgs}</div>
                                )}
                                </>
                            }
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" onClick={handlePopupClose}>Close</button>
                        <button type="submit" className="btn btn-primary">Save</button>
                    </Modal.Footer>
                </form>
        </Modal>
    )
}
export default AdminCompetenyClone;
AdminCompetenyClone.propTypes = {
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    // handleClose: PropTypes.func.isRequired    
};